import { Axios } from 'axios';
import apiClient from 'services/api/axios';
import { IAppNotificationsRes, ITelegramAttachDto, IAppNotificationWithPagRes } from 'store/app-notifications/types';
import { TableQueryParams } from 'hooks/table-params';

class NotificationService {
  api: Axios;

  constructor(api: Axios) {
    this.api = api;
  }

  getNotifications() {
    return this.api.get<IAppNotificationsRes>('/user/notifications');
  }

  getAllNotifications(params: TableQueryParams) {
    return this.api.get<IAppNotificationWithPagRes>('/user/notifications/all', { params });
  }

  setRead(id: number) {
    return this.api.get(`/user/notifications/${id}`);
  }

  attachTelegram(dto: ITelegramAttachDto) {
    return this.api.post('telegram/checkCode', dto);
  }
}

export default new NotificationService(apiClient);
